import { get, isImpersonated as isImpersonatedJwt } from './Auth__Jwt.res.js'

export const getJwt = get
export const isImpersonated = isImpersonatedJwt
